var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M17 21a10.07 10.07 0 0 1-4.74-1.19l-.45-.25a18 18 0 0 1-7.33-7.33l-.25-.45A10.07 10.07 0 0 1 3 7v-.67a2 2 0 0 1 .59-1.42l1.69-1.69a.75.75 0 0 1 1.18.15l2.25 3.86a1 1 0 0 1-.16 1.21l-1.89 1.89a.5.5 0 0 0-.09.59l.35.66a13.53 13.53 0 0 0 5.5 5.49l.66.36a.5.5 0 0 0 .59-.09l1.89-1.89a1 1 0 0 1 1.21-.16l3.86 2.25a.75.75 0 0 1 .15 1.18l-1.69 1.69a2 2 0 0 1-1.42.59H17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.afb70a6b.svg";
export { ForwardRef as ReactComponent };